import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Divider, Row, Col, Avatar, Space, Dropdown } from 'antd';
import { Brand } from "../Components/Brand";
import { SettingsRounded, ExpandMore } from "@mui/icons-material";


const HomeHeader = ({username, appsList = null}) => {
  const navigate = useNavigate();

  const handleNavigate = (route) => {
    navigate(route);
  }

  const menuItems = [
    {
      key: 'forms',
      label: 'Forms',
      onClick: () => handleNavigate('/forms')
    },
    ...(Array.isArray(appsList) && appsList.includes('reports') ? [{
      key: 'reports',
      label: 'Reports',
      onClick: () => handleNavigate('/reports')
    }] : []),
    {
      key: 'beta',
      label: 'BETA Model',
      onClick: () => handleNavigate('/beta/gam')
    },
    {
      key: 'touchpoints',
      label: "Touchpoints",
      onClick: ()=>handleNavigate('/beta/touchpoints')
    },
    {
      key: 'simulate',
      label: 'Simulate',
      onClick: () => handleNavigate('/beta/simulate')
    }
  ];

  return (
      <Row align={'middle'} justify={'center'} wrap={false}>
        <Brand companyId={localStorage.getItem('cid')} maxHeight={'50px'} />
        <Space size={'large'} className={'px-3'}>
          <Space>
            <Avatar size={'default'} style={{ background: '#0033ff' }}>
              {username && username.slice(0, 1).toUpperCase()}
            </Avatar>
            <Typography.Link style={{fontSize: '1rem', width: 150}} ellipsis={true} onClick={() => handleNavigate('/settings')} strong>{username}</Typography.Link>
          </Space>
          <Dropdown menu={{ items: menuItems }} placement="bottomRight">
            <Typography.Link ellipsis={true} style={{fontSize: '1.1rem'}}>
              More options <ExpandMore />
            </Typography.Link>
          </Dropdown>
        </Space>
      </Row>
  );
};

export default HomeHeader;